import { Component } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { withTransl } from 'shared/lib/i18n';

import BMXAuthenticationComponent from '../components/BMXAuthenticationComponent';

import {
  getBMXAccessToken,
  sendBMXCameraStatus,
} from '../../Building/actionCreators';

function withToken(WrappedComponent) {
  class BMXAuth extends Component {
    constructor(props) {
      super(props);
      this.state = {
        token: null,
        message: null,
      };
    }

    async componentDidMount() {
      const { getBMXAccessToken, buildingId, t } = this.props;
      try {
        this.setState({ message: t('common.loading') });
        const token = await getBMXAccessToken(buildingId);
        if (token) {
          this.setState({ token });
        } else {
          this.setState({ message: t('errors.cannotAuthenticate') });
        }
      } catch (error) {
        this.setState({ message: t('errors.authError') });
      }
    }

    render() {
      const { token, message } = this.state;
      const { buildingId, buildingName, cameraName } = this.props;
      const props = {
        buildingId,
        buildingName,
        cameraName,
        message,
      };
      return token ? (
        <WrappedComponent token={token} {...this.props} />
      ) : (
        <BMXAuthenticationComponent {...props} />
      );
    }
  }

  BMXAuth.defaultProps = {
    buildingName: '',
    cameraName: '',
  };

  BMXAuth.propTypes = {
    getBMXAccessToken: PropTypes.func.isRequired,
    buildingId: PropTypes.number.isRequired,
    buildingName: PropTypes.string,
    cameraName: PropTypes.string,
    t: PropTypes.func.isRequired,
  };

  const mapDispatchToProps = (dispatch) => ({
    getBMXAccessToken: (buildingId) => getBMXAccessToken(dispatch, buildingId),
    sendBMXCameraStatus: (buildingId, cameraId, data) =>
      sendBMXCameraStatus(dispatch, buildingId, cameraId, data),
  });

  return connect(null, mapDispatchToProps)(withTransl()(BMXAuth));
}

export default withToken;
